
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// window.$ = window.jQuery = require('jquery');

// require('bootstrap-sass');

// window.swal = require('sweetalert2');

require('fitvids')();

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
if (typeof Promise === 'undefined') {
    require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions.js');
}

Object.assign = require('object-assign')

window.Vue = require('vue');

window.Vue.component('businesses', require('./components/Business.vue').default);
window.Vue.component('member-profile', require('./components/MemberProfile').default);
window.Vue.component('editcamp', require('./components/EditCamp').default);
window.Vue.component('findacamp', require('./components/FindACamp').default);
window.Vue.component('search-a-camp', require('./components/SearchOptions').default);
window.Vue.component('display-camps', require('./components/DisplayCamps').default);

require('trumbowyg');
import VueTrumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import 'trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.min.js';

window.Vue.use(VueTrumbowyg);

import VueFuse from 'vue-fuse';
window.Vue.use(VueFuse);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-WP-Nonce': window.wpApiSettings.nonce,
    'X-Requested-With': 'XMLHttpRequest'
};
window.axios.defaults.baseURL = window.wpApiSettings.root
